import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { SVGInjector } from '@tanem/svg-injector'
import { clearMsgStatusAction } from '../utils/slices'
/*
  Usage:
  import { sendMsg, clearMsg } from '../utils/actions'

  sendMsg(dispatch, { MsgBody: 'FYI ....' })
  sendMsg(dispatch, { MsgLevel: 'success', MsgHeader: 'Print', MsgBody: 'Print done' })
  sendMsg(dispatch, { MsgLevel: 'error', MsgLevel: '..../sst-icon-error.svg', MsgHeader: 'Validation error', MsgBody: status })

  clearMsg(dispatch)
*/
export function MessageSection() {
  const dispatch = useDispatch()
  const { msgLevel, msgIconUrl, msgHeader, msgBody } = useSelector((state) => state.status)

  useEffect(() => {
    const mySVGsToInject = document.querySelectorAll('img.injectSVG')
    SVGInjector(mySVGsToInject)
  })

  const mIcon = (
    <>
      {msgIconUrl ? (
        <img
          data-src={msgIconUrl}
          className="globalMessage__icon iconic iconic-md injectSVG"
          alt="info"
        />
      ) : (
        <img
          data-src="assets/images/iconic/info.svg"
          className="globalMessage__icon iconic iconic-sm injectSVG"
          alt="info"
        />
      )}
    </>
  )
  const mHeader = <>{msgHeader ? <div className="globalMessage__header">{msgHeader}</div> : null}</>
  const mBody = <div className="globalMessage__body">{msgBody}</div>

  return (
    <>
      {msgBody ? (
        <div className={'globalMessage' + (msgLevel ? ' -' + msgLevel : '')} data-testid="globalMessage">
          <span className="globalMessage__close" onClick={() => dispatch(clearMsgStatusAction())} />

          {mIcon}

          <div className="globalMessage__text">
            {mHeader}
            {mBody}
          </div>
        </div>
      ) : null}
    </>
  )
}
